import Phaser from 'phaser'
import CameraController from '../components/camera_controller'
import Player from '../actors/player'
import Road from '../components/road'
import Spawner from '../components/spawner'
import { LAYER_PLAYER, LAYER_ROAD, LAYER_PARTICLES } from '../layers'

export default class GameScene extends Phaser.Scene {
  create () {
    if (process.env.NODE_ENV !== 'production') {
      window.scene = this
    }

    this.rnd = new Phaser.Math.RandomDataGenerator()
    this.cars = this.physics.add.group()
    this.objects = this.physics.add.group()

    this.setupParticles()

    this.player = new Player(this)
    this.cars.add(this.player)
    this.add.existing(this.player)
    this.player.initialize()
    this.player.setDepth(LAYER_PLAYER)
    this.player.x = 0
    this.player.y = 0

    this.road = new Road(this, this.player)
    this.add.existing(this.road)
    this.road.setDepth(LAYER_ROAD)

    this.cameraController = new CameraController(this, this.player)

    this.spawner = new Spawner(this, this.road)

    this.physics.add.collider(this.cars, undefined, (a, b) => {
      a.emit('collision', b)
      b.emit('collision', a)
    })

    this.physics.add.overlap(this.cars, this.objects, (car, object) => {
      object.onCollision(car, car instanceof Player)
    })

    this.input.keyboard.on('keyup-ESC', () => {
      this.scene.pause()
      this.scene.run('PauseScene')
    })

    this.scene.run('TitleScene', { game: this, player: this.player })
    this.scene.run('HudScene', { game: this, player: this.player })
  }

  update (time, delta) {
    this.road.update(time, delta)
    this.cameraController.update(time, delta)
    this.spawner.update(time, delta)

    if (this.restartTimer > 0) {
      this.restartTimer -= delta / 1000
      if (this.restartTimer <= 0) {
        this.restart()
      }
    }
  }

  setupParticles () {
    this.particles = this.add.particles('particles')
    this.particles.setDepth(LAYER_PARTICLES)

    this.collisionEmitter = this.particles.createEmitter({
      on: false
    })
  }

  gameover () {
    this.player.isGameOver = true
    this.cameraController.lookAtPlayer()
    this.restartTimer = 2
  }

  restart () {
    if (this.player.score === 0) {
      this.scene.restart('GameScene')
    } else {
      this.scene.pause()
      this.scene.run('HighscoresScene', { score: this.player.score })
    }
  }
}
